import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/common.service';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {
  resetPasswordForm: UntypedFormGroup;
  submitable = false;
  error = '';
  code = '';
  returnUrl: string;
  email: string;
  errorMessage: any;
  step2: boolean = false;
  step1: boolean = !this.step2;
  load: boolean = true;
  processing: boolean = false;
  showPassword: boolean = false;
  showConfirm: boolean = false;

  constructor(private router: Router,private route: ActivatedRoute, private dataservice: CommonService, private formBuilder: UntypedFormBuilder) {
    this.code = this.route.snapshot.paramMap.get('code');
    
    this.load = true;
    this.errorMessage = {fname:'',lname:'',email:'',organization:'',password:'',password_confirmation:''};
    // this.emailErrorMessage = {email:''};
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required]],
    });
    merge(this.frmCtrl.password.statusChanges,this.frmCtrl.password_confirmation.statusChanges, this.frmCtrl.password_confirmation.valueChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage(this.frmCtrl));
  }
  // convenience getter for easy access to form fields
  get frmCtrl() {
    return this.resetPasswordForm.controls;
  }
  /**
     * Form submit
     */
  onSubmit() {

    // stop here if form is invalid
    if (this.resetPasswordForm.invalid) {
      return;
    } else {
      this.processing = true;
      const data = {
        code: this.code,
        password: this.frmCtrl.password.value,
        password_confirmation: this.frmCtrl.password_confirmation.value
      };
      this.dataservice.sendPostRequest('/api/change-password', data).pipe(
        map((res: Response) => (JSON.stringify(res))))
        .subscribe(
          (response) => {
            this.processing = false;
            const result = JSON.parse(response);
            console.log(result);
            this.router.navigate(['login']);
          },
          (error) => {
            this.processing = false;
            if(error.status === 400){
              for (let err in error.error) {
                this.error += error.error[err][0]+'<br />';
              }
            } else {
              this.error = error.error.error_message;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            }
          });
    }
  }
  updateErrorMessage(frm) {
    this.submitable = true;
    if (frm.password && frm.password.hasError('required')) {
      this.errorMessage.password = 'Password is required';
      this.submitable = false;
    }else if (frm.password && frm.password.hasError('minlength')) {
      this.errorMessage.password = 'Password must be minimum 8 characters long';
      this.submitable = false;
    }
    
    if (frm.password_confirmation && frm.password_confirmation.hasError('required')) {
      this.errorMessage.password_confirmation = 'Confirm password';
      this.submitable = false;
    }else if (frm.password_confirmation && frm.password_confirmation.hasError('not_match')) {
      this.errorMessage.password_confirmation = 'Password do not match';
      this.submitable = false;
    }else if(frm.password && frm.password.value !== frm.password_confirmation.value){
      frm.password_confirmation.markAsDirty();
      frm.password_confirmation.markAsTouched();
      frm.password_confirmation.setErrors({'not_match':true});
    }
  }
}
